import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7af9aeb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Laufzeit:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Preis:", -1))

import { Subscription } from "@/store/model";
import { PropType } from "vue";
import BaseButton from "@/components/base/base-button.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  subscription: {
    type: Object as PropType<Subscription>,
    required: true,
  },
  selected: {
    type: Boolean,
    required: false,
    default: false,
  }
},
  emits: ["selected"],
  setup(__props, { emit }) {

const props = __props





function selectedSubscription() {
  emit("selected", props.subscription.id);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", null, [
      _createElementVNode("tr", null, [
        _hoisted_2,
        _createElementVNode("td", null, _toDisplayString(__props.subscription.duration), 1)
      ]),
      _createElementVNode("tr", null, [
        _hoisted_3,
        _createElementVNode("td", null, _toDisplayString(__props.subscription.price) + " € pro Jahr", 1)
      ])
    ]),
    _createVNode(BaseButton, {
      title: __props.selected ? 'Ausgewählt' : 'Buchen',
      disabled: __props.selected,
      onClick: selectedSubscription
    }, null, 8, ["title", "disabled"])
  ]))
}
}

})